import React from 'react';
import { Pane, BackButton, toaster } from 'evergreen-ui';
import PageHeader from 'components/shared/PageHeader';
import CreateOrUpdateMedication from 'components/organizations/CreateOrUpdateMedication';

export default ({ history, organization }: any) => {
  return (
    <>
      <PageHeader
        title="Create new medication"
        renderButtons={
          <BackButton
            marginLeft="auto"
            onClick={() =>
              history.push(`/orgs/${organization.slug}/medications`)
            }
          />
        }
      />

      <Pane width="500px">
        <CreateOrUpdateMedication
          organizationId={organization.id}
          onComplete={() => {
            toaster.success('Medication successfully created');
            history.push(`/orgs/${organization.slug}/medications`);
          }}
        />
      </Pane>
    </>
  );
};
